import * as amplitude from '@amplitude/analytics-browser';

// Initialize Amplitude
export const initAmplitude = () => {
  const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;

  if (apiKey) {
    amplitude.init(apiKey, {
      minIdLength: 1, // Allow short user IDs (Fora user_id can be < 5 chars)
      defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: false,
        fileDownloads: false,
      },
    });
    console.log('Amplitude initialized');
  } else {
    console.warn('Amplitude API key not found - analytics disabled');
  }
};

// Track event helper (fails silently if no API key)
export const trackEvent = (eventName, eventProperties = {}) => {
  const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
  if (!apiKey) return; // Safe no-op if not configured

  amplitude.track(eventName, {
    ...eventProperties,
    timestamp: new Date().toISOString(),
  });
};

// Set user identity (for later use)
export const setUserId = (userId) => {
  amplitude.setUserId(userId);
};

// Set user properties (for later use)
export const setUserProperties = (properties) => {
  const identifyEvent = new amplitude.Identify();
  Object.entries(properties).forEach(([key, value]) => {
    identifyEvent.set(key, value);
  });
  amplitude.identify(identifyEvent);
};
